import {
  Dispatch,
  RefObject,
  SetStateAction,
  useEffect,
  useMemo,
  useState,
} from 'react'

import debounce from 'lodash.debounce'

export type UseHeightTransitionType = ({
  componentRef,
}: {
  componentRef: RefObject<HTMLDivElement | null>
}) => {
  isExpanded: boolean | null
  setIsExpanded: Dispatch<SetStateAction<boolean | null>>
}

const useExpandableContent: UseHeightTransitionType = ({ componentRef }) => {
  const [isExpanded, setIsExpanded] = useState<boolean | null>(null)

  useEffect(() => {
    const resizeHandler = debounce(() => {
      if (componentRef.current) {
        const scrollHeight = componentRef.current.scrollHeight
        const clientHeight = componentRef.current.clientHeight
        const textTooLong = scrollHeight > clientHeight

        setIsExpanded(!textTooLong)
      }
    }, 100)

    const resizeObserver = new ResizeObserver(resizeHandler)

    if (componentRef.current) {
      resizeObserver.observe(componentRef.current)
    }

    return () => {
      resizeObserver.disconnect()
    }
  }, [componentRef])

  return useMemo(
    () => ({ isExpanded, setIsExpanded }),
    [isExpanded, setIsExpanded],
  )
}

export default useExpandableContent
